  import React, { useState } from 'react'
import GlobalSearch from "../../components/Search";
import Table from '../Client/detail/components/Building/Table';
import Heading from '../../components/Heading';
import { Box, Divider, Stack } from '@mui/material';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import Client from '../LeadCompliance/components/Filters/Client';
import { isAdmin } from '../../utils/helpers';
import { useCustomParams } from '../../hooks/useCustomParams';
import { useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

function Buildings() {
  const [search] = useCustomParams('search');
  const [client] = useCustomParams('client');
  const [searchParams, setSearchParams] = useSearchParams();
  const { totalUnits, totalRecords } = useSelector(state => state.buildingStats);


  const removeSearchParams = (paramsToRemove) => {
    // Create a copy of the current search params
    const newSearchParams = new URLSearchParams(searchParams);

    // Remove each parameter in the paramsToRemove array
    paramsToRemove.forEach((param) => {
      newSearchParams.delete(param);
    });

    // Set the updated search params
    setSearchParams(newSearchParams);
  };

  const removeFilter = () => {
    removeSearchParams(["search", "client"]);
  };
  return (
    <>
      <Heading title="All Buildings" />
      <div className="tickets-filter d-flex justify-content-space-between mt-4 bg-white">
        <Stack direction="row" spacing={2} alignItems="center">
          <GlobalSearch />
          {isAdmin() && <Client />}
          <div>
            {search || client ? (
              <p className="clear-filter" onClick={removeFilter}>
                Clear Filter
              </p>
            ) : (
              ""
            )}
          </div>
        </Stack>
        <Box className="d-flex">
          <Box className="mr-4">
            <p className="bottom-detail">
              {totalRecords} Buildings
            </p>
          </Box>

          <Divider orientation="vertical" flexItem />

          <Box className="ml-4">
            <p className="bottom-detail">{totalUnits} Units</p>
          </Box>
        </Box>
      </div>
      <Table />
    </>
  );
}

export default Buildings